import type { PrismaKeys, PrismaWhere } from '~/types'

/*
 * Correctly type the where schemas
 *
 * @param modelKey: The key of Prisma Model
 * @param where: The where filters
 */
export default function<K extends PrismaKeys> (modelKey: K, where: MaybeRef<PrismaWhere<K>>): PrismaWhere<K> {
  return unref(where)
}
